// PROVE 결정트리 사실 키·값의 사용자 표시 라벨. AiClassificationWorkspace(PROVE 탭)와
// 전체 탭의 결정트리 사전 점검 카드가 같은 표를 공유한다. 없는 값은 기계어 코드를 그대로
// 노출하지 않고 밑줄을 공백으로 풀어 읽을 수 있게 한다.

import cabinetObservationLabels from './cabinetObservationLabels.json';
import sourceDirectionLabels from './sourceDirectionLabels.json';
import productCompletionLabels from './productCompletionLabels.json';
import flowerWholeLabels from './flowerWholeLabels.json';
import {validateNoodleManifest} from './noodleSetEvidence';
const FACT_LABELS = {
  chapter91_domestic_accessibility_use: "시각장애인용 설계",
  chapter91_domestic_precious_component_status: "국내세분의 귀금속 적용 조건",
  chapter91_domestic_drive_status: "무브먼트 구동 방식",
  flower_component_manifest: "구성품 명세",
  noodle_component_manifest: "면류 세트 구성품 명세",
  milling_specification_confirmation: "현재 곡물 상품 사양 전체 확인",
  food_description_confirmation: "입력 설명의 상품 정보 확인",
  food_beef_percent: "입력된 쇠고기 비율(%)",
  food_weight_basis: "배합비 중량 기준",
  food_cooking: "가열·조리 상태",
  food_animal_ingredients: "동물성 재료 구성",
  food_product_form: "식품 형태·먹는 방법",
  food_container_net_g: "개별 용기 순중량(g)",
  food_homogenised: "미세 균질화 상태",
  chapter16_domestic_packaging_state: "밀폐 포장 상태",
  milling_grain: "분쇄 곡물의 종류",
  milling_process: "곡물 제조공정",
  milling_recipe: "곡물 외 첨가 성분",
  milling_product_use: "제품 용도·효능 표시",
  milling_test_basis: "시험성적서 측정 기준",
  chapter11_cereal_germ_status: "분리 배아 여부",
  chapter11_starch_percent_dry: "건조물 기준 전분 함량(%)",
  chapter11_ash_percent_dry: "건조물 기준 회분 함량(%)",
  chapter11_sieve_pass_500um_percent: "500µm 체 통과율(%)",
  chapter11_sieve_pass_2mm_percent: "2mm 체 통과율(%)",
  shape_form: "물품 형태",
  juice_use_form: "주스 사용 형태",
  juice_base_supply_state: "음료 원료의 수입 상태",
  juice_mixture_fruits: "혼합한 과일 전체",
  juice_component_pineapple: "파인애플 원료 제조 상태",
  juice_component_orange: "오렌지 원료 제조 상태",
  juice_component_apple: "사과 원료 제조 상태",
  juice_component_grape: "포도 원료 제조 상태",
  juice_material_kind: "즙을 낸 과일",
  juice_extraction: "주스 제조 방법",
  juice_recipe_profile: "첨가 성분",
  juice_water_process: "물의 처리 방법",
  juice_frozen: "수입 시 냉동 여부",
  juice_ingredients_description: "주스 원재료·함량 표시",
  juice_addition_purposes: "성분별 첨가 목적",
  juice_carbonation_process: "탄산가스 사용 공정",
  juice_milk_process: "유제품·발효 공정",
  juice_water_specification: "물 투입·농축환원 규격",
  juice_supply_directions: "포장 사용 방법·효능 표시",
  chapter20_brix_value_at_20c: "20℃ 기준 Brix(당도)",
  chapter20_juice_alcohol_percent_by_volume: "주스 알코올 함량(% vol)",
  cabinet_product_identity: "물품 자체의 종류",
  cabinet_component_manifest: "함께 수입하는 구성품 목록",
  cabinet_additional_description: "추가 상품 설명",
  product_description: "물품 구성·사용 설명",
  cabinet_supply_configuration: "수입하는 수납장 구성",
  cabinet_equipment_relationship: "다른 기계·장비와의 관계",
  cabinet_placement: "수납장 설치 위치",
  cabinet_installation: "수납장 이동·영구 설치 방식",
  cabinet_function: "수납장 기능",
  cabinet_play_use: "실제 수납·놀이 용도",
  cabinet_material_composition: "수납장 구성 재료",
  item_role: "품목 상태",
  outer_shell_material: "겉감(바깥 면) 재료",
  protective_apparel_status: "방호·차폐용 의류 여부",
  garment_terms_before_protective_rule: "문언에 적힌 의류 종류",
  article_role: "품목 상태",
  machine_family: "기계군",
  machine_or_mechanical_appliance_family: "기계군",
  self_propelled_status: "자주식 여부",
  work_platform_status: "작업대 구조 여부",
  lifting_or_handling_equipment_status: "권양·하역 장비 장착 여부",
  item_kind: "완성품·부분품 구분",
  upper_material: "갑피 재료",
  outer_sole_material: "바깥 바닥 재료",
  waterproof_6401_construction: "제6401호 방수 구조",
  outer_sole_affixed_status: "방직용 섬유 갑피의 바깥 바닥 부착 여부",
  sports_footwear_status: "소호주상 스포츠화 여부",
  tennis_like_style: "테니스화류 여부",
  footwear_style: "신발 종류",
  protective_metal_toe_cap: "보호용 금속 토캡",
  ankle_coverage: "피복 높이",
  plug_strap_construction: "플러그 삽입 끈 구조",
  leather_strap_big_toe_construction: "가죽 끈 구조",
  footwear_component_type: "신발 부분품 종류",
  footwear_component_material: "신발 부분품 재료",
  upper_attached_to_outer_sole: "갑피와 바깥 바닥 결합 여부",
  construction: "원단 구조",
  garment_type: "의류 종류",
  garment_gender: "성별 구분",
  textile_material: "주재료",
  surface_treatment: "표면 처리",
  fabric_source: "원단 법정 호",
  derived_fabric_source_heading: "규칙으로 파생한 원단 호",
  special_fabric_base_kind: "원단 기본 구조",
  coating_material_family: "코팅 재료",
  chapter59_plastic_coating_visibility_status: "플라스틱 코팅 육안 식별성",
  chapter59_manual_bend_7mm_status: "7mm 굽힘 파단 여부",
  chapter59_plastic_embedding_status: "플라스틱 완전 매몰·양면 피복 여부",
  chapter59_partial_design_coating_status: "부분 무늬 코팅 여부",
  chapter59_cellular_plastic_reinforcement_status: "셀룰러 플라스틱 보강재 여부",
  chapter59_heading5811_exclusion_status: "제5811호 누비 직물 여부",
  chapter59_rubberised_textile_route: "고무처리 원단 조건",
  chapter59_cellular_rubber_reinforcement_status: "셀룰러 고무 보강재 여부",
  chapter59_other_coating_visibility_status: "그 밖의 코팅 육안 식별성",
  chapter59_note6_exclusion_status: "제59류 주 제6호 제외 여부",
  chapter59_heading5907_residual_scope_status: "제5907호 잔여범위 여부",
  single_yarn_decitex: "단사 섬도",
  material_base: "기본 재질",
  product_category: "제품 유형",
  use: "주된 용도",
};

const VALUE_LABELS = {
  yes: "예",
  no: "아니오",
  true: "예",
  false: "아니오",
  waistcoat: "웨이스트코트·조끼",
  outer_or_suit_jacket: "재킷(아우터·슈트 재킷)",
  suit: "슈트",
  ensemble: "앙상블",
  nightwear: "잠옷·파자마",
  underpants: "팬티·브리프",
  swimwear: "수영복",
  tracksuit: "트랙슈트",
  ski_suit: "스키슈트",
  bra: "브래지어",
  other_garment: "그 밖의 의류(앞치마·작업복·특수복 등)",
  textile_fabric: "방직용 섬유 직물·편물",
  plastic_sheet: "플라스틱 시트",
  rubber_sheet: "고무 시트",
  footwear: "완성 신발",
  part: "신발 부분품",
  gaiter: "각반",
  rubber_plastics: "고무·플라스틱",
  leather: "가죽",
  textile: "방직용 섬유",
  other: "기타",
  composition_leather: "콤퍼지션레더",
  leather_composition: "가죽·콤퍼지션레더(이전값)",
  tennis_like: "테니스화·농구화·체조화·훈련화류",
  ski_boots: "스키·스노보드 부츠",
  sports_other: "그 밖의 법정 스포츠화",
  below_ankle: "발목 아래",
  covers_ankle_not_knee: "발목을 덮고 무릎은 덮지 않음",
  covers_knee: "무릎을 덮음",
  upper: "갑피",
  upper_part: "갑피 부분품",
  stiffener: "갑피 보강재",
  outer_sole: "바깥 바닥",
  heel: "뒷굽",
  removable_insole: "갈아 끼울 수 있는 안창",
  knit: "편물·뜨개질",
  woven: "직물",
  nonwoven: "부직포",
  felt: "펠트",
  woven_or_knit: "직물·편물",
  plastics: "플라스틱",
  rubber: "고무",
  visible_without_relying_on_colour_change: "색상 변화와 무관하게 육안 식별 가능",
  not_visible: "육안 식별 불가",
  bends_without_fracturing_at_15_to_30_c: "15~30℃에서 7mm 굽힘 시 파단되지 않음",
  fractures: "7mm 굽힘 시 파단됨",
  not_completely_embedded_or_visibly_coated_both_sides: "완전 매몰·양면 전체 피복 아님",
  completely_embedded_or_both_sides_visible: "완전 매몰 또는 양면 전체 피복",
  not_partial_design_coating: "부분 무늬 코팅 아님",
  partial_design_coating: "부분 코팅으로 무늬 형성",
  not_cellular_plastic_with_textile_merely_reinforcing: "직물이 단순 보강재가 아님",
  textile_merely_reinforcing_cellular_plastic: "직물이 셀룰러 플라스틱의 단순 보강재",
  not_heading5811: "제5811호 누비 직물 아님",
  heading5811: "제5811호 누비 직물",
  men: "남성·소년용",
  women: "여성·소녀용",
  unisex: "남녀공용",
  cotton: "면",
  wool: "양모",
  cashmere: "캐시미어",
  fine_animal_hair: "섬수모",
  silk: "견",
  synthetic: "합성섬유",
  artificial: "재생·반합성섬유",
  linen: "아마·린넨",
  shirt: "셔츠",
  tshirt: "티셔츠",
  blouse: "블라우스",
  trousers: "바지·쇼츠",
  jacket: "슈트 재킷·블레이저",
  anorak: "아노락·파카류",
  coat: "코트류",
  dress: "드레스",
  skirt: "스커트",
  sweater: "스웨터·카디건",
  glove: "장갑",
  scarf: "스카프·숄",
  sock: "양말",
  other_garment: "그 밖의 의류",
};

// 같은 값이 축에 따라 다른 뜻을 가질 때(part=신발 부분품 vs 기계 부분품) 축 우선 라벨.
const FACT_VALUE_LABELS = {
  ...cabinetObservationLabels,
  item_role: {
    complete_machine: "완성 기계·기기",
    incomplete_essential_character: "본질적 특성을 갖춘 미완성 기계",
    part: "부분품",
    accessory: "부속품",
  },
  article_role: {
    complete_machine: "완성 기계·기기",
    incomplete_essential_character: "본질적 특성을 갖춘 미완성 기계",
    part: "부분품",
    accessory: "부속품",
  },
  machine_family: {
    pulley_tackle_or_hoist: "풀리 태클·호이스트",
    winch_or_capstan: "윈치·캡스턴",
    jack_or_vehicle_raising_hoist: "잭·차량 들어올리는 호이스트",
    crane_or_derrick: "크레인·데릭",
    works_truck_fitted_with_crane: "크레인 장착 작업트럭",
    fork_lift_truck: "포크리프트 트럭",
    works_truck_with_lifting_handling_equipment: "권양·하역 장비 장착 작업트럭",
    self_propelled_elevating_work_platform: "자주식 고소작업대",
    lift_or_skip_hoist: "리프트·스킵 호이스트",
    pneumatic_elevator_or_conveyor: "공기식 엘리베이터·컨베이어",
    continuous_action_elevator_or_conveyor: "연속식 엘리베이터·컨베이어",
    escalator_or_moving_walkway: "에스컬레이터·무빙워크",
    teleferic_or_funicular_traction: "삭도·케이블카 견인장치",
    industrial_robot: "산업용 로봇",
    other_lifting_handling_machine: "그 밖의 권양·하역 기계",
    bulldozer_or_angledozer: "불도저·앵글도저",
    grader_or_leveller: "그레이더·레벨러",
    scraper: "스크레이퍼",
    tamping_machine_or_road_roller: "탬핑기·로드롤러",
    mechanical_shovel_excavator_or_shovel_loader: "메커니컬 셔블·굴착기·셔블로더",
    pile_driver_or_extractor: "파일드라이버·파일익스트랙터",
    snow_plough_or_blower: "제설기",
    coal_rock_cutter_or_tunnelling_machine: "석탄·암석 절단기·터널 굴진기",
    boring_or_sinking_machinery: "보링·싱킹 기계",
  },
};

export function humanizeCode(value) {
  const text = String(value ?? "");
  if (!/^[a-z0-9]+(?:_[a-z0-9]+)+$/.test(text)) return text;
  return text.replace(/_/g, " ");
}

export function factLabel(key) {
  if (flowerWholeLabels.facts[key]) return flowerWholeLabels.facts[key];
  if (productCompletionLabels.facts[key]) return productCompletionLabels.facts[key];
  if (sourceDirectionLabels.facts[key]) return sourceDirectionLabels.facts[key];
  if (FACT_LABELS[key]) return FACT_LABELS[key];
  const text = String(key || "");
  const exclusion = text.match(/^chapter(\d+)_exclusion_status$/);
  if (exclusion) return `제${exclusion[1]}류 주 제외 물품 여부`;
  const family = text.match(/^chapter(\d+)_article_family$/);
  if (family) return `제${family[1]}류 물품 종류(호)`;
  const subfamily = text.match(/^chapter(\d+)_subheading_family$/);
  if (subfamily) return `제${subfamily[1]}류 소호`;
  if (text === "article_role") return "품목 상태";
  if (text === "sibling_exclusions_confirmed") return "형제 소호 배제 확인";
  const chapterAxis = text.match(/^chapter(\d+)_(.+)$/);
  if (chapterAxis) return `제${chapterAxis[1]}류 ${humanizeCode(chapterAxis[2])}`;
  return text || "분류 사실";
}

export function valueLabel(value, factKey) {
    if(factKey === 'noodle_component_manifest' && value && typeof value === 'object' && Array.isArray(value.components)) {
      const review=validateNoodleManifest(value);
      return `${value.components.length}개 구성품 · ${!review.valid?'형식 확인 필요':review.status==='paused'?'자료 확인 대기':review.status==='conflict'?'자료 충돌':review.status==='ready_for_comparison'?'비교 자료 입력됨':review.status==='confirmation_required'?'확인 전':'자료 추가 필요'}`;
    }
    if(factKey === 'flower_component_manifest' && value && typeof value === 'object' && Array.isArray(value.components))
      return `${value.components.length}개 구성품 · ${value.paused ? '자료 확인 대기' : value.confirmed ? '관찰값 확인함' : '확인 전'}`;
    const text = String(value ?? "");
    if (text === 'edit_required') return '수정 중 · 미확인';
    if (text === 'unknown' || text === 'undetermined') return '미확인 · 모르겠습니다';
    if ((productCompletionLabels.facts[factKey] && String(factKey).endsWith('_specification_confirmation') || factKey === 'milling_specification_confirmation') && /^[a-f0-9]{64}$/.test(text)) return '현재 답변과 사양 일치 확인';
    if (flowerWholeLabels.values[factKey]?.[text]) return flowerWholeLabels.values[factKey][text];
    if (productCompletionLabels.values[factKey]?.[text]) return productCompletionLabels.values[factKey][text];
    if (String(factKey).startsWith('direction_') && String(factKey).endsWith('_description_confirmation') && /^[a-f0-9]{64}$/.test(text)) return '입력 설명의 상품 정보 확인함';
    if (sourceDirectionLabels.values[factKey]?.[text]) return sourceDirectionLabels.values[factKey][text];
    if (factKey === 'food_description_confirmation' && /^[a-f0-9]{64}$/.test(text)) return '입력 설명의 상품 정보 확인함';
    const foodLabels={food_description_confirmation:{manual:'직접 입력'},food_weight_basis:{finished:'완제품 전체 중량',raw_recipe:'조리 전 투입량',other:'다른 기준'},food_cooking:{cooked:'가열해 익힘',raw_preserved:'생고기·단순 보존',other:'다른 처리'},food_animal_ingredients:{beef_flesh_only:'쇠고기 살만 사용',liver_offal:'간·내장 포함',sausage:'소시지 또는 소시지 기반',mixed:'다른 동물성 재료 포함',extract:'추출액·육즙'},food_product_form:{meal:'식사용 음식',soup:'수프·국물',sauce:'소스·혼합 조미료',stuffed:'속 채운 식품',other:'다른 형태'}};
    if(foodLabels[factKey]?.[text])return foodLabels[factKey][text];
    const juiceLabels = {
      juice_material_kind: { pineapple:'파인애플 한 종류', orange:'오렌지 한 종류', apple:'사과 한 종류', grape:'포도 한 종류', mixed:'두 종류 이상 혼합', other:'그 밖의 원료' },
      juice_extraction: { pressed:'짜거나 압착해 얻은 즙', pulp:'퓌레·페이스트', powder:'가루·결정', other:'다른 제조 방법' },
      juice_recipe_profile: { juice_only:'즙과 물 외 첨가 없음', added_ingredients:'첨가 성분 있음' },
      juice_water_process: { none:'물을 넣거나 빼지 않음', concentrated:'수분 제거·농축', restored:'제거한 물만큼 환원', extra:'물을 더 넣어 희석' },
      juice_frozen: { yes:'냉동', no:'냉동하지 않음' },
    };
    if (juiceLabels[factKey]?.[text]) return juiceLabels[factKey][text];
  if (factKey === 'juice_use_form') return ({ready_to_drink:'바로 마시는 제품',concentrated_juice:'농축 주스 · 희석해서 사용',beverage_base:'다른 음료에 넣는 혼합 원료',other:'그 밖의 사용 방법',unknown:'모르겠습니다'})[text] || text;
  const scoped = factKey ? FACT_VALUE_LABELS[String(factKey).split("@")[0]] : null;
  if (scoped && scoped[text]) return scoped[text];
  return VALUE_LABELS[text] || humanizeCode(text);
}
